import store from '../store';
import { vsprintf } from 'sprintf-js';

export function getText(key, args = []) {
    const { texts } = store.getState().app;

    if (!texts.hasOwnProperty(key)) {
        console.error(`getText method provided with invalid key ${key}`);
        return null;
    }

    try {
        return vsprintf(texts[key], args);
    } catch (e) {
        console.error(key);
        console.error(e);
    }
}

export const hasText = key => {
    const { texts } = store.getState().app;

    if (!texts.hasOwnProperty(key)) {
        console.log(`getText method provided with invalid key ${key}`);
        return null;
    }

    return true;
};
